<template>
    <!--<v-card>-->
        <!--<v-card-title primary-title>-->
            <!--<div class="headline">{{profile.name}}</div>-->
            <!--<div>{{ profile.description }}</div>-->
        <!--</v-card-title>-->
        <!--<v-card-actions>-->
            <!--<v-btn flat>Listen now</v-btn>-->
        <!--</v-card-actions>-->
    <!--</v-card>-->

    <v-card @click="$emit('select')">
        <v-card-media class="text-xs-center">
            <img :src="provider.Logo"
                 style="max-width:100px; max-height: 100px; margin: 20px;">
        </v-card-media>
        <v-card-actions class="white">
            <span>{{ provider.Name }}</span>
            <v-spacer></v-spacer>
            <v-btn icon>
                <v-icon>compare_arrows</v-icon>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: 'ProfileProviderCard',
        props: ['provider'],
        data() {
            return {};
        },
        computed: {},
        methods: {},
        created() {},
    };
</script>



// WEBPACK FOOTER //
// ProfileProviderCard.vue?694b2aca